import Vue from 'vue';
import tower, { towerController } from '@jarvis/tower-h5';
import { Icon, Loading } from 'som-ui';

Vue.use(Icon);
Vue.use(Loading);
const { appInfo } = towerController;
function formatNumber(n) {
    const str = n.toString();
    return str[1] ? str : `0${str}`;
}

export function formatTime(date) {
    date = new Date(date)
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    const t1 = [year, month].map(formatNumber).join('/');
    const t2 = [hour, minute, second].map(formatNumber).join(':');

    return `${t1}`;
}




export default {
    isWeiXinBrowser() {
        return !!(/micromessenger/.test(navigator.userAgent.toLowerCase()));
    },
    isAndroid() {
        return navigator.userAgent.indexOf('Android') > -1;
    },
    isIos() {
        return navigator.userAgent.indexOf('iPhone') > -1;
    },
    isApp() {
        return navigator.userAgent.indexOf('cheyipai') > -1 || appInfo.su_AppScheme === 'cheyipai';
    },
    isRedmi() {
        return navigator.userAgent.indexOf('Redmi') > -1;
    },
    fetchParams(name) {
        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
        var regexS = `[\\?&]${name}=([^&#]*)`;
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.href);
        // eslint-disable-next-line eqeqeq
        if (results == null || results == undefined) { return ''; } else { return results[1]; }
    }
};
// 加载中toast
export function showLoadingToast() {
    Vue.$som.loading.show();
}

// 隐藏加载中toast
export function hideLoadingToast() {
    Vue.$som.loading.hide();
}

/*
 * showToast 普通提示框
 * @params 参数名称 参数类型 参数是否必填 参数说明
 * @params v String 是 提示内容
 * 返回值 无
 * */
export function showToast(v, t) {
    Vue.$som.toast.show({
        text: v,
        type: t
    });
}

// 获取地址栏参数
export function getUrlParams(url = window.location.href) {
    let obj = {};
    let reg = /[?&][^?&]+=[^?&]+/g;
    let arr = url.match(reg);
    if (arr) {
        arr.forEach(function (item) {
            let tempArr = item.substring(1).split('=');
            let key = decodeURIComponent(tempArr[0]);
            let val = decodeURIComponent(tempArr[1]);
            obj[key] = val;
        });
    }
    return obj;
}

export function userAgentFlag() {
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) { // eslint-disable-line
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

/**
 * 格式化金额，逗号分割
 * @param {number|string} money
 * @return: string
 */
export const formatMoneyWithSplit = (money) => {
    let result = '';
    let counter = 0;
    const num = (money || 0).toString();
    for (let i = num.length - 1; i >= 0; i -= 1) {
        counter += 1;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i !== 0) {
            result = `,${result}`;
        }
    }
    return result;
};

export const getAppData = () => (
    new Promise((resolve, reject) => {
        try {
            tower.invokeModule(
                `${appInfo.su_AppScheme}://getAppDataInfo/cypAppDataInfo`,
                {},
                (err, res) => {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(res);
                }
            );
        } catch (e) {
            console.log('@getAppData error', e);
            showToast(e);
        }
    })
);






// export const https = {
//     get: function() {
//         return new Promise((resolve, reject) => {

//         })
//     },
//     post: function() {}
// }



// WEBPACK FOOTER //
// ./src/utils/index.js